<div class="col-sm-2 key-log-filter">
    <div class="key-log-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <div class="key-log-filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="availableCheckbox" #availableCheckbox (change)="changeFilter()">
                <label for="availableCheckbox"><svg-checked></svg-checked></label>
                <span>Available</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="signedOutCheckbox" #signedOutCheckbox (change)="changeFilter()">
                <label for="signedOutCheckbox"><svg-checked></svg-checked></label>
                <span>Signed Out</span>
            </label>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/key-log-filter/key-log-filter.component.html